import Header from "../components/common/Header"
import { useRecoilValue } from "recoil"
import quizPhaseState from "../recoil/quizPhase"
import QuizMain from "../components/QuizPage/QuizMain"
import QuizIntro from "../components/QuizPage/QuizIntro"
import QuizPreinfo from "../components/QuizPage/QuizPreinfo"
import QuizSubmit from "../components/QuizPage/QuizSubmit"
import styled from "styled-components"
import useSavedQuizData from "../hooks/QuizPage/useSavedQuizData"
import Footer from "../components/common/Footer"
import useScrollReset from "../hooks/useScrollReset"
import ProgressBar from "../components/QuizPage/ProgressBar"

const QuizPage = () => {
  const quizPhase = useRecoilValue(quizPhaseState)

  useScrollReset()
  useSavedQuizData()

  return (
    <>
      <Header />
      <QuizContentsDiv>
        {quizPhase === "intro" && <QuizIntro />}
        {quizPhase === "preinfo" && <QuizPreinfo />}
        {quizPhase === "main" && (
          <>
            <QuizMain />
            <ProgressBar />
          </>
        )}
        {quizPhase === "submit" && <QuizSubmit />}
      </QuizContentsDiv>
      <Footer />
    </>
  )
}

export default QuizPage

const QuizContentsDiv = styled.div`
  width: 100vw;
  min-height: 100vh;
  padding: 100px 35px 45px;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: space-between;
  position: relative;

  @media ${({ theme }) => theme.device.pc} {
    width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
`
